import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from '../../../../utils/redux-injectors';
import { CourtSettings, VenueShowcaseItem } from '../../../../types';
import { homeSaga } from './saga';
import { HomeState } from './types';

const initialState: HomeState = {
  message: '',
  loading: false,
  courtSettings: [],
  courtSettingsLoading: false,
  venueShowcase: [],
  venueShowcaseLoading: false,
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    fetchStatusRequest(state) {
      state.loading = true;
    },
    fetchStatusSuccess(state, action: { payload: string }) {
      state.loading = false;
      state.message = action.payload;
    },
    fetchStatusFailure(state) {
      state.loading = false;
      state.message = 'API unavailable';
    },
    fetchCourtSettingsRequest(state) {
      state.courtSettingsLoading = true;
    },
    fetchCourtSettingsSuccess(state, action: PayloadAction<CourtSettings[]>) {
      state.courtSettingsLoading = false;
      state.courtSettings = action.payload;
    },
    fetchCourtSettingsFailure(state) {
      state.courtSettingsLoading = false;
      state.courtSettings = [];
    },
    fetchVenueShowcaseRequest(state) {
      state.venueShowcaseLoading = true;
    },
    fetchVenueShowcaseSuccess(state, action: PayloadAction<VenueShowcaseItem[]>) {
      state.venueShowcaseLoading = false;
      state.venueShowcase = action.payload;
    },
    fetchVenueShowcaseFailure(state) {
      state.venueShowcaseLoading = false;
      state.venueShowcase = [];
    },
  },
});

export const homeActions = homeSlice.actions;
export const homeReducer = homeSlice.reducer;
export const initialHomeState = initialState;

export function useHomeSlice() {
  useInjectReducer({ key: 'home', reducer: homeSlice.reducer });
  useInjectSaga({ key: 'home', saga: homeSaga });
  return { actions: homeSlice.actions };
}
